var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BlogPage', {
    attrs: {
      "blogHeaderTitle": _vm.blogHeaderTitle,
      "blogItems": _vm.blogItems,
      "isRecentBlogs": true
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }